<template>
  <div class="financingOptions">
    <img
      v-if="lenders[lender]?.logo"
      :src="lenders[lender].logo"
      class="vendorLogo mb-4"
      data-cy="vendorLogo"
    />
    <RadioGroup
      v-model="selectedLoanOfferId"
      class="mb-4"
      condensed
      :options="loanOfferOptions"
      data-cy="loanOfferOptions"
    />
    <div class="disclaimer">
      This Loan Estimate is intended solely for demonstration purposes, and the
      user should not rely on information developed through its use. Neither the
      Financing Partner nor Sera Systems warrant that the information contained
      herein or generated hereby is accurate, reliable, current, or error-free.
      The Financing Partner and Sera Systems make no representation or warranty
      regarding the availability of this financing option. Payments presented
      are only available to qualified borrowers. All offers are subject to
      credit approval. Must be at least 18 years old to qualify. Additional
      conditions and limitations apply. Terms are subject to change without
      notice. Terms may include promotional offers which may be lost if terms
      and conditions are not met.
    </div>
  </div>
</template>

<script lang="ts">
// TODO: Figure out another way in our tests to stub components using setup syntax
export default {
  name: "FinancingOptions"
};
</script>

<script lang="ts" setup>
import { computed, watch } from "vue";

import { LoanOffer } from "../types";
import { useFinancingAvailable } from "./useFinancingAvailable";

const { lenders, selectedLoanOfferId } = useFinancingAvailable();

const props = defineProps({
  lender: {
    type: String,
    default: ""
  },
  loanOffers: {
    type: Array as () => LoanOffer[],
    default: () => []
  }
});

const loanOfferOptions = computed(() => {
  return props.loanOffers.map((program) => {
    return {
      label: program.description,
      value: program.id
    };
  });
});

watch(
  loanOfferOptions,
  (val) => {
    if (val.length) {
      selectedLoanOfferId.value = val[0].value;
    }
  },
  { immediate: true }
);

defineExpose({ loanOfferOptions });
</script>

<style lang="scss" scoped>
.financingOptions {
  .disclaimer {
    font-size: 12px;
  }
  .vendorLogo {
    max-height: 33px;
  }
}
</style>
